// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-paired-channel-row[data-v-f2e5bf58]{height:100%}.no-paired-channel-row .col[data-v-f2e5bf58]{border-left:1px solid #d8d8d8}.no-paired-channel-row .col[data-v-f2e5bf58]:first-child{border-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
